var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.975 7.83752V4.46252L40.6 4.08752C40.4125 4.08752 39.2875 3.90002 37.4125 3.90002C29.725 3.90002 24.1 6.15002 20.9125 10.0875C18.475 8.58752 15.1 7.65002 11.1625 7.65002C9.28751 7.65002 7.97501 7.83752 7.97501 7.83752L4.41251 8.40002L4.60001 11.5875C4.78751 17.2125 7.60001 27.9 17.35 27.9H17.725V34.275C10.6 35.2125 4.60001 37.65 4.60001 37.65V41.4H42.1V37.65C42.1 37.65 36.1 35.2125 28.975 34.275V28.275C40.7875 28.0875 43.975 14.775 43.975 7.83752ZM23.35 33.9H21.475V23.4C21.475 23.4 21.1 17.025 15.85 17.025C15.85 17.025 18.6625 18.525 19.4125 23.9625C18.6625 24.15 17.9125 24.15 17.35 24.15C8.72501 24.15 8.35001 11.5875 8.35001 11.5875C8.35001 11.5875 9.47501 11.4 11.1625 11.4C14.725 11.4 20.5375 12.15 22.225 17.2125C23.1625 8.77502 32.725 7.65002 37.4125 7.65002C39.1 7.65002 40.225 7.83752 40.225 7.83752C40.225 7.83752 40.225 24.7125 28.4125 24.7125H27.1C27.1 20.9625 30.85 15.3375 30.85 15.3375C25.225 17.2125 25.225 24.525 25.225 24.525V33.9H23.35Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlant);
export default __webpack_public_path__ + "static/media/plant.2b9ae67c4fc8fd6ba18c86a0c0b027dd.svg";
export { ForwardRef as ReactComponent };